import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useCallback, useLayoutEffect, useState } from 'react';
import { Alignment, Fit, Layout, useRive } from '@rive-app/react-canvas';
import cn from 'clsx';
import { RIVE_ANIMATION_STATIC_COIN_URL } from "../shared/constants";
import { isTestingJest } from "../utils/jest";
import { ANIMATED_STATIC_COIN_ARTBOARD } from "./constants";
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * Rive animation for static coin.
 * Size: 2.4rem x 2.4rem
 */
export var AnimatedStaticCoinRive = function AnimatedStaticCoinRive(_ref) {
  var style = _ref.style,
    className = _ref.className,
    startAnimation = _ref.startAnimation,
    disableAnimation = _ref.disableAnimation,
    dataTestId = _ref['data-testid'];
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isLoaded = _useState2[0],
    setIsLoaded = _useState2[1];
  var _useRive = useRive({
      src: RIVE_ANIMATION_STATIC_COIN_URL,
      artboard: ANIMATED_STATIC_COIN_ARTBOARD,
      layout: new Layout({
        fit: Fit.Cover,
        alignment: Alignment.Center
      }),
      onLoad: function onLoad() {
        return setIsLoaded(true);
      },
      useOffscreenRenderer: true
    }),
    rive = _useRive.rive,
    RiveComponent = _useRive.RiveComponent;
  var isLoading = !rive || !isLoaded;
  var handlePlay = useCallback(function () {
    if (rive && !disableAnimation) {
      rive.reset({
        artboard: ANIMATED_STATIC_COIN_ARTBOARD
      });
      rive.play();
    }
  }, [disableAnimation, rive]);
  useLayoutEffect(function () {
    if (startAnimation) {
      handlePlay();
    }
  }, [handlePlay, startAnimation]);
  return /*#__PURE__*/_jsx("div", {
    className: cn('tw-w-2.4 tw-h-2.4', isLoading && 'tw-animate-pulse tw-w-2.4 tw-h-2.4 tw-bg-warning-300 tw-rounded-full', className),
    "data-testid": dataTestId,
    children: !isTestingJest && /*#__PURE__*/_jsx(RiveComponent, {
      style: style,
      onMouseOver: handlePlay,
      className: "tw-w-2.4 tw-h-2.4"
    })
  });
};
export default AnimatedStaticCoinRive;